import React from 'react';
import { AnalyticsContext } from '@atlaskit/analytics-next';
import { extensionIdToAnalyticsAttributes } from './extensionIdToAnalyticsAttributes';
import { setupContextKeysFromSessionStorage } from './extensionLoadedFilter';

export const ForgeUIExtensionAnalyticsContext = ({
	extensionId,
	localId,
	children,
}: {
	children: React.ReactNode;
	extensionId: string;
	localId: string;
}): React.JSX.Element => {
	setupContextKeysFromSessionStorage();

	return (
		<AnalyticsContext
			data={{
				forgeUIAttributes: {
					localId,
					...extensionIdToAnalyticsAttributes(extensionId),
				},
			}}
		>
			{children}
		</AnalyticsContext>
	);
};
